export const SAVE_BLADE_AND_COILS_DATA = 'SAVE_BLADE_AND_COILS_DATA'

export const saveDataInternally = data => dispatch => {
  dispatch({
    type: SAVE_BLADE_AND_COILS_DATA,
    payload: data,
  })
}
